import { QuestProgressMetadataSchema } from "./quest-progress";
import { QUEST_APP, QUEST_TYPE } from "./quest.enums";
import { z } from "zod";

export const CreateOrUpdateQuestProgressDtoSchema = z.object({
  questId: z.number().positive(),
  metadata: QuestProgressMetadataSchema as z.ZodTypeAny, // Cast to avoid deep type instantiation
});
export type CreateOrUpdateQuestProgressDto = z.infer<typeof CreateOrUpdateQuestProgressDtoSchema>;

export const CreateQuestCompletionDtoSchema = z.object({
  questId: z.number().positive(),
});
export type CreateQuestCompletionDto = z.infer<typeof CreateQuestCompletionDtoSchema>;

export const ClaimQuestRewardsDtoSchema = z.object({
  questCompletionId: z.string().min(1),
});
export type ClaimQuestRewardsDto = z.infer<typeof ClaimQuestRewardsDtoSchema>;

export const GetQuestByTypesDtoSchema = z.object({
  types: z
    .union([z.string(), z.array(z.nativeEnum(QUEST_TYPE))])
    .transform((value) =>
      typeof value === "string"
        ? value
            .split(",")
            .map((item) => item.trim())
            .filter(Boolean)
        : (value ?? []),
    )
    .pipe(z.array(z.nativeEnum(QUEST_TYPE))),
  // Defaulted rather than required so clients predating the arena split keep resolving to hub quests.
  app: z.nativeEnum(QUEST_APP).default(QUEST_APP.HUB),
});
export type GetQuestByTypesDto = z.infer<typeof GetQuestByTypesDtoSchema>;

// Param DTOs for NestJS validation
export const QuestIdParamSchema = z.object({
  questId: z.coerce.number().positive(),
});
export type QuestIdParam = z.infer<typeof QuestIdParamSchema>;

export const QuestCompletionIdParamSchema = z.object({
  questCompletionId: z.string().min(1),
});
export type QuestCompletionIdParam = z.infer<typeof QuestCompletionIdParamSchema>;

export const CommentXPostBodyDtoSchema = z.object({
  comment: z
    .string()
    .min(1, "Twitter post cannot be empty")
    .max(280, "Twitter post must be 280 characters long maximum"),
});
export type CommentXPostBody = z.infer<typeof CommentXPostBodyDtoSchema>;
